import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants";

const IMPORT_TYPES = sharedConstants.USER_CSV_IMPORT.CSV_IMPORT_TYPES;
export type CsvImportType = (typeof IMPORT_TYPES)[keyof typeof IMPORT_TYPES];

export interface AppsAppGroupIdUserImportsDatatableParams extends BaseTableParams {
  groupby?: never;
  sortby?: never;
  sortdir?: never;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

export interface AppsAppGroupIdUserImportsDatatableResultItem extends BaseTableResultItem {
  id: string;
  start_time: number;
  name: string;
  columns: number;
  total_rows: number;
  total_record_count?: number | null;
  import_count: number;
  malformed_count: number;
  no_id_count: number;
  warning_rows: number;
  is_done: boolean;
  segment_id: string;
  cancelled: boolean;
  download_link: string;
  error_report_download_link?: string;
  has_error_report: boolean;
  is_uploaded_by_current_developer: boolean;
  should_make_filterable: boolean;
  developer: string;
  import_type: CsvImportType;
  has_hit_user_limit: boolean;
  failed: boolean;
}

export type AppsAppGroupIdUserImportsDatatableResult = TableResult<AppsAppGroupIdUserImportsDatatableResultItem>;
